import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isCopilotLicensedAndEnabledUser } from 'owa-copilot-settings-utils/lib/utils/isCopilotLicensedAndEnabledUser';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import {
    shouldShowSuggestedDrafts,
    type SuggestedDraftsComposeView,
} from './shouldShowSuggestedDrafts';

export function isDabSuggestedRepliesEnabled(
    mailboxInfo: MailboxInfo,
    composeViewState?: SuggestedDraftsComposeView
): boolean {
    if (
        !isGlobalFeatureEnabled('mon-copilot-dab-experiment-draft-reply') ||
        !isCopilotLicensedAndEnabledUser(mailboxInfo) ||
        !isBizchatSidepaneEnabled(mailboxInfo)
    ) {
        return false;
    }

    if (composeViewState && !shouldShowSuggestedDrafts(composeViewState)) {
        return false;
    }

    return true;
}
